import Menu from "@mui/material/Menu";
import Paper from "@mui/material/Paper";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import makeStyles from "@mui/styles/makeStyles";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";

import { useMemo } from "react";
import { globalColors } from "../../Utils/colors";
import { ListItemTextPropType } from "./interface";
import { sidebarValueConstants } from "./sidebarutils";

import {
  CopyLinkIcon,
  DeleteIcon,
  DuplicateIcon,
  EditIcon,
  PreviewIcon,
  PublishIcon,
  SelectIcon,
} from "../../components/Custom/Buttons/ButtonIcons";

const useStyles = makeStyles({
  ulRoot: {
    padding: "0px",
  },
});

const ListItemTextWrapper = ({ children }: ListItemTextPropType) => {
  return (
    <span
      style={{
        fontFamily: "Poppins",
        fontSize: "14px",
      }}
    >
      {children}
    </span>
  );
};

const deletedOptions = [
  {
    label: "Delete forever",
    iconRenderer: () => <DeleteIcon disabled={false} />,
  },
  {
    label: "Move to draft",
    iconRenderer: () => <DuplicateIcon disabled={false} />,
  },
  { label: "Select", iconRenderer: () => <SelectIcon disabled={false} /> },
];

const draftOptions = [
  { label: "Edit", iconRenderer: () => <EditIcon disabled={false} /> },
  { label: "Delete", iconRenderer: () => <DeleteIcon disabled={false} /> },
  {
    label: "Copy Edit link",
    iconRenderer: () => <CopyLinkIcon disabled={false} />,
  },
  {
    label: "Duplicate",
    iconRenderer: () => <DuplicateIcon disabled={false} />,
  },
  { label: "Select", iconRenderer: () => <SelectIcon disabled={false} /> },
  {
    label: "Publish",
    iconRenderer: () => (
      <PublishIcon disabled={false} color={globalColors.headingBlack} />
    ),
  },
];

const publishOptions = [
  { label: "Edit", iconRenderer: () => <EditIcon disabled={false} /> },
  {
    label: "Preview",
    iconRenderer: () => (
      <PreviewIcon disabled={false} color={globalColors.headingBlack} />
    ),
  },
  { label: "Delete", iconRenderer: () => <DeleteIcon disabled={false} /> },
  { label: "Copy link", iconRenderer: () => <CopyLinkIcon disabled={false} /> },
  {
    label: "Copy Edit link",
    iconRenderer: () => <CopyLinkIcon disabled={false} />,
  },
  {
    label: "Duplicate",
    iconRenderer: () => <DuplicateIcon disabled={false} />,
  },
  { label: "Select", iconRenderer: () => <SelectIcon disabled={false} /> },
  {
    label: "Move to draft",
    iconRenderer: () => <DuplicateIcon disabled={false} />,
  },
];

export default function ActionsPopover({
  anchorEl,
  clickHandler,
  onClose,
  open,
  selectedMode,
}: any) {
  const classes = useStyles();

  const options = useMemo(() => {
    if (selectedMode === sidebarValueConstants.deleted) {
      return deletedOptions;
    } else if (selectedMode === sidebarValueConstants.drafted) {
      return draftOptions;
    } else if (selectedMode === sidebarValueConstants.published) {
      return publishOptions;
    } else {
      return [];
    }
  }, [selectedMode]);

  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      classes={{ list: classes.ulRoot }}
    >
      <Paper sx={{ width: 180, maxWidth: "100%" }}>
        <MenuList>
          {options.map((option) => {
            return (
              <MenuItem key={option.label} onClick={() => clickHandler(option.label)}>
                <ListItemIcon>{option.iconRenderer()}</ListItemIcon>
                <ListItemText>
                  <ListItemTextWrapper>{option.label}</ListItemTextWrapper>
                </ListItemText>
              </MenuItem>
            );
          })}
        </MenuList>
      </Paper>
    </Menu>
  );
}
